import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-products" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "home-title" }

import imageAlt from '@/components/web/imageAlt.vue';
import CertificateZoom from '@/components/web/content/CertificateZoom.vue';
import { usePageData } from '@/composables/usePageData';
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';

type imgItem = {
    imgUrl: string;
    text: string;
}

// 响应语言切换的计算属性

// 产品图片集合

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeService',
  setup(__props) {

const { t, tm } = useI18n();

const localizedProducts = computed<imageAltTitleItem[]>(() => [
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/customized-low-power-led-lamp-cup-aluminium-die-casting-products-1-!j.webp",
        alt: t('index.service.products.items.ledLamp.alt'),
        title: t('index.service.products.items.ledLamp.title'),
        link: "/case-studies/customized-low-power-led-lamp-cup-aluminium-die-casting-products"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/die-casting-zinc-alloy-speaker-shell-parts-1-!j.webp",
        alt: t('index.service.products.items.speakerShell.alt'),
        title: t('index.service.products.items.speakerShell.title'),
        link: "/case-studies/die-casting-zinc-alloy-speaker-shell-parts"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/14144515442-!j.webp",
        alt: t('index.service.products.items.heatSink.alt'),
        title: t('index.service.products.items.heatSink.title'),
        link: "/case-studies/sandblasting-aluminum-die-casting-led-lamp-heat-sink-accessories"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/metal-die-casting-bellows-joint-ad-12-aluminum-alloy-1-!j.webp",
        alt: t('index.service.products.items.bellowsJoint.alt'),
        title: t('index.service.products.items.bellowsJoint.title'),
        link: "/case-studies/metal-die-casting-bellows-joint-ad-12-aluminum-alloy"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2106/die-casting-custom-electronic-crane-scale-shell-1-!j.webp",
        alt: t('index.service.products.items.craneShell.alt'),
        title: t('index.service.products.items.craneShell.title'),
        link: "/case-studies/die-casting-custom-electronic-crane-scale-shell"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2106/aluminum-die-casting-electric-motor-fan-blade-1-!j.webp",
        alt: t('index.service.products.items.fanBlade.alt'),
        title: t('index.service.products.items.fanBlade.title'),
        link: "/case-studies/aluminum-die-casting-electric-motor-fan-blade"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/aluminum-alloy-die-casting-automobile-and-motorcycle-transfer-adapters-structure-parts-1-!j.webp",
        alt: t('index.service.products.items.transferAdapter.alt'),
        title: t('index.service.products.items.transferAdapter.title'),
        link: "/case-studies/aluminum-alloy-die-casting-automobile-and-motorcycle-transfer-adapters-structure-parts"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2012/customized-machining-appearance-machinery-parts-for-foundry-die-castings-1-!j.webp",
        alt: t('index.service.products.items.machineryParts.alt'),
        title: t('index.service.products.items.machineryParts.title'),
        link: "/case-studies/customized-machining-appearance-machinery-parts-for-foundry-die-castings"
    }
]);




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('index.service.products.title')), 1),
      _createVNode(imageAlt, {
        "image-alt-collection": localizedProducts.value,
        "has-tail-hr": false
      }, null, 8, ["image-alt-collection"])
    ])
  ]))
}
}

})